import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { safeLogger } from "../../utils/logger";

type FeaturesStateType = {
  features: string[];
  lastUpdated: number;
  purchaseInProgress: boolean;
  purchaseSuccess: boolean;
};

const initialState: FeaturesStateType = {
  features: [],
  lastUpdated: 0,
  purchaseInProgress: false,
  purchaseSuccess: false,
};

// const initialState: FeaturesStateType = {
//   features: getInitialFeatures(),
//   lastUpdated: Date.now(),
//   purchaseInProgress: false,
//   purchaseSuccess: false,
// };

const featuresSlice = createSlice({
  name: "features",
  initialState,
  reducers: {
    // עדכון features מ-localStorage
    setFeatures: (state, action: PayloadAction<string[]>) => {
      safeLogger.log("Features updated with new data");
      state.features = action.payload;
      state.lastUpdated = Date.now();
      // state.purchaseSuccess = false; // טיהור דגל ההצלחה
    },

    // התחלת תהליך קנייה
    setPurchaseInProgress: (state) => {
      safeLogger.log("Purchase in progress");
      state.purchaseInProgress = true;
      state.purchaseSuccess = false;
    },

    // הצלחת קנייה - דגל זה יגרום לכל הקומפוננטות להתעדכן
setPurchaseSuccess: (state) => {
  state.purchaseInProgress = false;
  state.purchaseSuccess = true;
},

    // ניקוי דגל ההצלחה אחרי שכל הקומפוננטות התעדכנו
    clearPurchaseSuccess: (state) => {
      state.purchaseSuccess = false;
    },

    // איפוס מצב הקנייה
    resetPurchaseState: (state) => {
      state.purchaseInProgress = false;
      state.purchaseSuccess = false;
    },
  },
});

export const {
  setFeatures,
  setPurchaseInProgress,
  setPurchaseSuccess,
  clearPurchaseSuccess,
  resetPurchaseState,
} = featuresSlice.actions;

export default featuresSlice.reducer;
